// import { createContext, useContext, useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';

// const ThemeContext = createContext();

// export const ThemeProvider = ({ children }) => {
//     const [theme, setTheme] = useState('light'); // 'light' or 'dark'

//     const toggleTheme = () => {
//         setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
//     };
//     console.log(location, 'location here');
//     useEffect(() => {
//         const root = document.documentElement;

//         if (theme === 'dark') {
//             root.classList.remove('light-mode');
//             root.classList.add('dark-mode');
//         } else {
//             root.classList.remove('dark-mode');
//             root.classList.add('light-mode');
//         }
//     }, [theme]);

//     return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
// };

// export const useTheme = () => {
//     const context = useContext(ThemeContext);
//     if (!context) {
//         throw new Error('useTheme must be used within a ThemeProvider');
//     }
//     return context;
// };

import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const ThemeContext = createContext(null);
const THEME_STORAGE_KEY = 'impactfoundry-theme';
const THEME_CLASSES = {
    light: 'light-mode',
    dark: 'dark-mode',
};

const getPreferredTheme = () => {
    return "light"
    if (typeof window === 'undefined') return 'light';

    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;

    const prefersDark =
        typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
};

const applyThemeClass = (theme) => {
    if (typeof document === 'undefined') return;

    const root = document.documentElement;
    const nextClass = THEME_CLASSES[theme] ?? THEME_CLASSES.light;
    root.classList.remove(...Object.values(THEME_CLASSES));
    root.classList.add(nextClass);
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(getPreferredTheme);

    useEffect(() => {
        applyThemeClass(theme);
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(THEME_STORAGE_KEY, theme);
        }
    }, [theme]);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const handleStorage = (event) => {
            if (event.key === THEME_STORAGE_KEY && (event.newValue === 'light' || event.newValue === 'dark')) {
                setTheme(event.newValue);
            }
        };

        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    const toggleTheme = useCallback(() => {
        setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
    }, []);

    const value = useMemo(
        () => ({
            theme,
            isDarkMode: theme === 'dark',
            setTheme,
            toggleTheme,
        }),
        [theme, toggleTheme]
    );

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
